import axios from "axios";
import { SystemErrorNotice } from "@/modules/admin/objects/systemErrorNotice";

export const getSystemErrorNotice = async (): Promise<SystemErrorNotice> => {
  const url = `${process.env.VUE_APP_KTZN_BE_ENDPOINT}/biz/system_error_notice/get`;
  const res = await axios.post(url, {});
  return {
    system_status: res.data.system_error_notice.system_status,
    title_in_error: res.data.system_error_notice.title_in_error,
    message_in_error: res.data.system_error_notice.message_in_error,
    title_disabled: res.data.system_error_notice.title_disabled,
    message_disabled: res.data.system_error_notice.message_disabled,
  };
};

export const defaultSystemErrorNotice = (): SystemErrorNotice => ({
  system_status: "WORKING",
  title_in_error: "",
  message_in_error: "",
  title_disabled: "",
  message_disabled: "",
});
